import React from "react"
import { graphql } from "gatsby"
import InnerPageLayout from '../../layout/inner-page'
import { Container, Row, Col } from '../../../../shared-ui/components/ui/wrapper'
import SectionTitle from '../../../../shared-ui/components/ui/section-title'
import ServiceBox from '../../../../shared-ui/components/box-large-image/layout-two'
import Heading from '../../../../shared-ui/components/ui/heading'
import PricingTable from '../../../../shared-ui/components/ui/pricing-table/layout-two'
import Text from '../../../../shared-ui/components/ui/text'
import Button from '../../../../shared-ui/components/ui/button'
import BoxIcon from '../../../../shared-ui/components/box-icon/layout-two'
import { ServiceWrap, FeaturedServicesWrap, GalleryWrap, GalleryBottom } from './index.style'
import { IntroWrap, IntroHeading, IntroText, PricingWrap, LocationsWrap, LocationBoxWrap } from './index.style'
import CTASection from '../../components/cta-section'
import ContactFormSection from '../../components/contact-form-section'
import FrequentlyAskedQuestionsSection from '../../components/frequently-asked-questions-section'
import Image from '../../../../shared-ui/components/image'
import Img from "gatsby-image"
import Swiper from '../../../../shared-ui/components/ui/swiper'
import { renderRichText } from "gatsby-source-contentful/rich-text";

const LocationPage = ({location, data, ...props }) => {  
    
  const bannerImage = data.bannerImage;
  const locationPage = data.locationPage;  

  const aboutSectionTitleStyle = {
    mb: '60px',
    responsive: {
        small: {
            mb: '47px'
        }
    }
  };


  const aboutHeadingStyle = {
    layout: 'highlight',
    mr: '48px'
};
const aboutSubheadingStyle = {
    as: 'h6',
    mt: '30px',
    mb: '15px'
};
const aboutDescStyle = {
    fontSize: '18px',
    mb: '20px'
};
const sliderSettings = {
    slidesPerView: 1,
    loop: true,
    arrows: true,
    autoplay: true,
    paginationStyle: {
        mt: '50px'
    },
    breakpoints: {
        1499: {
            slidesPerView: 3
        },

        991: {
            slidesPerView: 2
        },

        767: {
            slidesPerView: 1

        },
        320: {
            slidesPerView: 1
        }
    }
}
  return (    
    <InnerPageLayout location={location} 
        bannerImg={bannerImage} 
        browserTitle={locationPage.pageBrowserTitle}
        pageData={{ title : locationPage.pageName, tagline : "Una oficina sin preocupaciones."}}> 

        {locationPage.introTitle && 
        <IntroWrap>
            <Container>
                <Row>
                    <Col lg={12}>
                        <SectionTitle
                            {...aboutSectionTitleStyle}                            
                            title={locationPage.introTitle}                           
                        />
                    </Col>
                </Row>
                <Row>
                    {/*<Col lg={{ span: 4, offset: 1 }}>
                        <IntroHeading>
                           <Heading {...aboutHeadingStyle} ><mark>6</mark> AÑOS TRABAJANDO PARA NUESTROS CLIENTES EN CHIHUAHUA</Heading>
                           <Heading {...aboutSubheadingStyle} >Empresa orgullasemente Chihuahuense.</Heading>
                        </IntroHeading>
                    </Col>*/}
                    <Col lg={12}>
                        <IntroText>
                            <Text {...aboutDescStyle} dangerouslySetInnerHTML={{
                                                    __html: locationPage.introBody.childMarkdownRemark.html,
                                                }} />
                              
                            {/*path && <Button to={path} icon="far fa-long-arrow-right" {...aboutBtnStyle}>Conocenos</Button>*/}
                        </IntroText>
                    </Col>
                </Row>
            </Container>
        </IntroWrap>}

    
        <LocationsWrap>
            <Container>
            <Row>
                    <Col lg={12}>
                        <SectionTitle
                            mb="40px"
                            title="Nos ubicamos en Chihuahua capital,<br/>en una de las <span>mejores zonas comerciales</span>."
                            subtitle="Nuestra Ubicación"
                        />
                    </Col>
                </Row>
            <Row>                                
                <Col lg={6} pr="3rem">
                    <Text {...aboutSubheadingStyle}>
                        {locationPage.title} 
                    </Text>
                    <Text {...aboutDescStyle}>
                        {locationPage.summaryText}
                    </Text>  
                    <Button to={locationPage.scheduleVisitSalesLink} target="_blank">Agendar Visita</Button>                    
                </Col>
            
                <Col lg={6}>
                    <LocationBoxWrap>
                        <Img fluid={locationPage.primaryPhoto.fluid} alt="Video preview" align="left" />
                    </LocationBoxWrap>
                </Col>                                
                </Row>
            </Container>
          </LocationsWrap>  
          <GalleryWrap>
          <Container>
                <Row>
                    <Col lg={12}>
                        <SectionTitle
                            mb="40px"
                            title="Vísitanos y conoce nuestas<br/><span>instalaciones de primer nivel</span>."
                            subtitle="Nuestras Instalaciones"
                        />
                    </Col>
                </Row>
                <Row>      
                <Col lg={12}>              
                        <Swiper settings={sliderSettings}>
                            {locationPage.photos.map((item, i) => (
                                <div className="item" key={i}>
                                    <img src={item.fixed.src} alt="Slider" />
                                </div>                        
                            ))}
                        </Swiper>
                        </Col>
                </Row>
                <Row>      
                <Col lg={12}>     
                        <GalleryBottom >
                            {renderRichText(locationPage.neighborhoodText)}   
                        </GalleryBottom>    
                </Col>
                </Row>
            </Container>
            </GalleryWrap>                                                
        {locationPage.availableServices && <FeaturedServicesWrap>
            <Container>
                <Row>
                    <Col lg={12}>
                        <SectionTitle
                            mb="40px"
                            title="Nuestra  <span>amplia gama de servicios</span><br/> le ayudará a mantenerlo enfocado."
                            subtitle="Servicios"
                        />
                    </Col>
                </Row>
                <Row>
                    {locationPage.availableServices.map((item, i) => (
                        <Col lg={4} md={6} key={`box-icon-2nd-${i}`}>
                            <BoxIcon
                                boxStyles={{ mt: "30px" }}
                                id={item.id}
                                title={item.title}
                                desc={item.shortDescription}
                                path={""}                           
                                //icon={item.iconCode}
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
        </FeaturedServicesWrap>}
        <ContactFormSection />
        <CTASection /> 
        
    </InnerPageLayout>)
}

LocationPage.defaultProps = {
    aboutSectionTitleStyle: {
        mb: '60px',
        responsive: {
            small: {
                mb: '47px'
            }
        }
    },
    aboutHeadingStyle: {
        layout: 'highlight',
        mr: '48px'
    },
    aboutSubheadingStyle: {
        as: 'h6',
        mt: '30px'
    },
    aboutDescStyle: {
        fontSize: '18px',
        mb: '20px'
    },
    aboutBtnStyle: {
        varient: 'texted',
        icondistance: '4px'
    }
}
 
export default LocationPage

export const pageQuery = graphql`
  query GetLocationPageContent($urlCode: String!) {
    bannerImage : file(relativePath: { eq: "legacy_images/parallax-virtual-office2.jpg" }) {
        childImageSharp {
           gatsbyImageData(
                width: 1024
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
           )
        }
      }
      locationPage : contentfulLocation(urlCode : {eq : $urlCode}){
        id
        contentful_id
        name
        title
        summaryText
        primaryPhoto {
            fluid(maxWidth: 1900, quality: 100) {
                # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
                ...GatsbyContentfulFluid
            }
            fixed(width: 368, height:230, quality: 100) {
                # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
                ...GatsbyContentfulFixed
            }
        }
        photos {
            fixed(width: 450, height:360, quality: 100) {
                # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
                ...GatsbyContentfulFixed
            }
        }
        scheduleVisitSalesLink
        neighborhoodText {
            raw
        }        
        availableServices {
            id
            title
            shortDescription
        }
    }        
  }
`
